import throttle from 'lodash/throttle';
import { useCallback, useEffect, useRef, useState } from 'react';

// We need to manually track a scale factor to apply to the hotspot locations.
// This is because the browser will scale and clip the image in order to both
// preserve the image aspect ratio AND cover the entire viewport.
export default function useHotspotHelper () {
  const imgRef = useRef();
  const [{ imgSize, scaleFactor }, setState] = useState({
    imgSize: null,
    scaleFactor: 0,
  });
  const computeScaleFactor = useCallback(
    () => {
      const img = imgRef.current;
      if (img) {
        const imgWidth = img.naturalWidth;
        const imgHeight = img.naturalHeight;
        const clientWidth = img.clientWidth;
        const clientHeight = img.clientHeight;

        const imgAspectRatio = (imgWidth / imgHeight);
        const clientAspectRatio = (clientWidth / clientHeight);
        const sf = (clientAspectRatio < imgAspectRatio)
            ? (clientHeight / imgHeight)
            : (clientWidth / imgWidth);

        setState({
          scaleFactor: sf,
          imgSize: {
            aspectRatio: imgAspectRatio,
            height: imgHeight,
            width: imgWidth,
          },
        });
      }
    },
    []
  );
  useEffect(() => {
    const handleResize = throttle(computeScaleFactor);
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [computeScaleFactor]);

  return {
    computeScaleFactor,
    imgRef,
    imgSize,
    scaleFactor,
  };
}
